module.exports = __webpack_public_path__ + "img/aio-logo@3x.b68fcdef.png";